module.exports = __webpack_public_path__ + "img/layernote.841ec344.svg";